import React from 'react';
import BusinessUnitsManager from '../business-units-manager';

const BusinessUnitsTab = props => (
  <div>
    <BusinessUnitsManager {...props} />
  </div>
);

export default BusinessUnitsTab;



/** WEBPACK FOOTER **
 ** ./src/containers/team-manager/business-units-tab.js
 **/